module.exports = __webpack_public_path__ + "img/eye-linear-20x20.214c4b62.svg";